export const CREDIT_CARD_INFO = 'creditCardInfo' as const;
export const CREDIT_CARD_INFO_IS_LOADED = 'isCreditCardLoaded' as const;
export const SUBSCRIPTION_INFO = 'subscriptionInfo' as const;
export const SUBSCRIPTION_INFO_V2 = 'subscriptionInfoV2' as const;
export const SELECTED_TIER = 'selectedTier' as const;
export const SELECTED_DISCOUNT_TYPE = 'selectedDiscountType' as const;
export const SELECTED_PAYMENT_PROVIDER = 'selectedPaymentProvider' as const;
export const CREDIT_CARD_FORM_STATUS = 'creditCardFormStatus' as const;
export const PAYPAL_STATUS = 'paypalStatus' as const;
export const SWITCHING_PLANS = 'isSwitchingPlans' as const;
export const UPDATING_BILLING_INFO = 'isUpdatingBillingInfo' as const;
export const UPDATED_BILLING_INFO = 'updatedBillingInfo' as const;
export const PAYPAL_REDIRECT_URL = 'paypalRedirectUrl' as const;
export const IS_ANONYMOUS_UPGRADE = 'isAnonymousUpgrade' as const;
export const AVAILABLE_PRODUCTS = 'availableProducts' as const;
export const SPECIAL_OFFER_PRODUCTS = 'specialOfferProducts' as const;
export const PP_VENDOR_SKU = 'paypalVendorSku' as const;
export const PP_PRODUCT_ID = 'paypalProductId' as const;
export const PP_TIER = 'tier' as const;
export const PP_DISCOUNT_TYPE = 'discountType' as const;
export const PP_DURATION_TYPE = 'durationType' as const;
export const PP_SPECIAL_OFFER_CODE = 'specialOfferCode' as const;
export const IS_PENDING_PURCHASE = 'isPendingPurchase' as const;
export const PAYPAL_COMPLETE = 'paypalComplete' as const;
export const INVALID_CREDIT_CARD = 'invalidCreditCard' as const;
export const SERVER_ERROR_TYPE = 'serverErrorType' as const;
export const SERVER_ERROR_MESSAGE = 'serverErrorMessage' as const;
export const IS_PENDING_PAYMENT_UPDATE = 'isPendingPaymentUpdate' as const;
export const MOBILE_MESSAGE = 'mobileMessage' as const;
export const PARTNER_UPGRADE_ENTITLEMENT_ID = 'partnerUpgradeEntitlementId' as const;
export const PARTNER_UPGRADE_TIER = 'partnerUpgradeTier' as const;
export const PARTNER_UPGRADE_PARTNER_NAME = 'partnerUpgradePartnerName' as const;
export const PARTNER_UPGRADE_USER_CONFIRMED = 'partnerUpgradeUserConfirmed' as const;
export const PREVIOUS_PLAN = 'previousPlan' as const;
export const FAMILY_PLAN_PARENT_EMAIL = 'familyPlanParentEmail' as const;
